import { type SexAssignedAtBirth } from '@feature/information-gathering/information-gathering.model';
import { InformationGatheringForm } from './information-gathering-form';
import { SexAssignedAtBirthField } from './sex-assigned-at-birth-field';
import { useInformationGatheringJourney } from './use-information-gathering-journey';

interface SelfDetailsFormData {
	sexAssignedAtBirth: SexAssignedAtBirth | '';
}

export function SelfDetailsScreen() {
	const { draft, saveDraft, goNext, goBack } = useInformationGatheringJourney();

	function submit(data: SelfDetailsFormData) {
		saveDraft({ ...draft, patient: { ...draft.patient, sexAssignedAtBirth: data.sexAssignedAtBirth } });
		goNext();
	}

	return (
		<InformationGatheringForm
			title='View.CreateNewMessage.InformationGathering.SelfDetails.Title'
			description='View.CreateNewMessage.InformationGathering.SelfDetails.Description'
			defaultValues={{ sexAssignedAtBirth: draft.patient.sexAssignedAtBirth }}
			onSubmit={submit}
			goBack={goBack}
		>
			<SexAssignedAtBirthField />
		</InformationGatheringForm>
	);
}
